import { AfterViewInit, Component, ContentChild, ContentChildren, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { NgbDatepicker, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerConfig, NgbCalendar, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { BookingService } from '../../../../core/services/booking.service';
import * as moment from 'moment';
import { NavigationEnd, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'environment';
import { ToastrService } from 'ngx-toastr';


declare let gtag: (property: string, value: any, configs: any) => {};
@Component({
  selector: 'app-search-type-selection',
  templateUrl: './search-type-selection.component.html',
  styleUrls: ['./search-type-selection.component.scss'],
  providers: [NgbDatepickerConfig] // add NgbDatepickerConfig to the component providers
})
export class SearchTypeSelectionComponent implements OnInit, AfterViewInit {
  infoWindowOpened = null;
  previousInfoWindow = null;

  /* Calendar variables */
  dateModel: NgbDateStruct; // NgModel of the current selected date
  
  @ViewChild("bookingByDate") testTemplate: TemplateRef<any>;
  @ViewChild('dp') datepicker: NgbDatepicker;
  public myMoment: string;

  // Google maps view variables
  public agmZoom: number = 11;
  public agmLatitude: number = -33.4942075;
  public agmLongitude: number = -70.6355676;

  public plantSelected: string = null;
  public alertSelect: number = 0;
  public addressSelected: string = null;
  public btnCalendar = 1;
  public btnMaps = 1;
  public reference: string = null;
  public codePlant: string;
  public latitude: string;
  public longitude: string;
  public dataPlants: any = [];
  

  openedWindow: number = null; // Contains the plant "id (index of the array)"
  @ViewChild('informacionImportante') informacionImportante:ElementRef;
  /* Ngb-datepicker properties */
  outsideDays;
  minimumDate;
  maximumDate;
  disabledDays;

  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private bookingService: BookingService,
    private router: Router,
    private ngxLoader: NgxUiLoaderService,
    private toastr: ToastrService
  ) { 
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.modalService.open(this.informacionImportante, { size: 'lg', centered: true, windowClass: 'informacion-modal' }).result.then((result) => {
        gtag('event', 'Boton_Entendido', {'event_category': 'Boton_Entendido', 'event_label': 'Boton_Entendido', 'value': 'Boton_Entendido'});
      }, (reason) => {
        gtag('event', 'Boton_Entendido', {'event_category': 'Boton_Entendido', 'event_label': 'Boton_Entendido', 'value': 'Boton_Entendido'});
      });
    });
    this.ngxLoader.stopLoader('selectType-loader');
  }

  ngOnInit() {
    this.setCalendarConfig();
    this.bookingService.resetVariables();
    this.authService.getChannel();
    this.authService.getTokenInit();
  }

  /* This sets the initial calendar configuration > No sundays and min/max date range */
  public setCalendarConfig() {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const lastDate = new Date(year, month, 0);
    this.minimumDate = { year, month, day }; // Minimum available date
    this.maximumDate = { year: year, month: month, day: lastDate.getDate() }; // Maximum available date
    this.outsideDays = 'hidden';

    // sundays are disabled
    this.disabledDays = (date: NgbDate) => {
      const d = new Date(date.year, date.month - 1, date.day);
      return d.getDay() === 0;
    };
  }

  selectToday() {
    const now = new Date();
    this.dateModel = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate(),
    };
    this.btnCalendar = 0;
  }

  onDateSelect(event) {
    this.btnCalendar = 0;
  }
  getCalendarAvailability(event, includeNextMonth = false){
    console.log(this.datepicker);
    const month = event.month;
    const year =  event.year;
    const lastDateInMonth = new Date(year, month, 0);
    const systemDate = new Date();
    this.bookingService.getCalendarAvailability(month, year).subscribe((response) =>{
      if(response.message && response.status){
        this.disabledDays = (date: NgbDate) => {
          const d = new Date(date.year, date.month - 1, date.day);
          return !(response.message.find(x => x.day === (moment(d)).format('YYYY-MM-DD')) !== null  && response.message.find(x => x.day === (moment(d)).format('YYYY-MM-DD')) !== undefined); 
        };

        if(response.message.length > 0){
          let firstAvailabilityDay = moment(response.message[0].day);
          this.dateModel = { year: year, month: month, day: firstAvailabilityDay.date() };
          this.btnCalendar = 0;
          if(includeNextMonth)
          console.log("test");
          //this.datepicker.navigateTo(this.dateModel);
        }
        else{
          if (lastDateInMonth.getDate() == systemDate.getDate() && !includeNextMonth) {
            includeNextMonth = true;
            event.month += 1;
            if (event.month > 12) {
              event.month = 1;
              event.year += 1;
            }
            return this.getCalendarAvailability(event, includeNextMonth);
          }
          else this.toastr.error("Agenda No disponible");
        }
      }
      this.ngxLoader.stopLoader('selectType-loader');
    });
  }
  public getAvailabilityinNextMonth(month, year){
    var init_date = `${month}-01-${year}`;
    var end_date = `${month}-31-${year}`;
    var daysInMonth = new Date(year, month, 0).getDate();
    this.bookingService.getAvailabilityByPlantAndMonth(init_date, end_date).subscribe((response) =>{
      if(response.message && response.status){
        this.maximumDate = { year: year, month: month, day: daysInMonth };
      }
    });
  }
 
  /* Disables holydays and looks for availability of booking for rfest of the days */
  pickUpDate(event) {
    this.ngxLoader.startLoader('selectType-loader');
    var month = event.month + 1;
    var year = event.year;
    if(month > 12){
      month = 1;
      year += 1; 
    }
    this.getAvailabilityinNextMonth(month, year);
    this.getCalendarAvailability(event);
   
  }

  /* Disable days based on the ms mandatory returned days */
  public isDisabled(availableDays, year, month) {
    const daysOfMonth = new Date(year, month, 0).getDate(); // This returns the total days of the month (number)
    const disabledDates: NgbDateStruct[] = [];
    /* This finds and push to the disabled days all sundays */
    for (let i = 0; daysOfMonth >= i; i++) {
      const date = new Date(year, month - 1, i);
      if (date.getDay() === 0) {
        disabledDates.push({ year, month, day: date.getDate() });
      }
    }
    /* This looks for all holydays that comes in the not-worked-days service */
    availableDays.message.days.forEach(element => {
      disabledDates.push({ year, month, day: element.day });
    });
    /* Then the disabled days are set */
    this.disabledDays = (dateStruct: NgbDateStruct) => {
      return disabledDates.find(date => new NgbDate(date.year, date.month, date.day).equals(dateStruct));
    };
  }

  /* Get available plants from plants ms */
  getPlants(content) {
    this.ngxLoader.startLoader('selectType-loader');
    gtag('event', 'Reserva1', {'event_category': 'Reserva1', 'event_label': 'Reserva1', 'value': 'Reserva1'});
    this.bookingService.getPlants().subscribe(
      res => {
        // console.log(res);
        if (res.status === true) {
          this.ngxLoader.stopLoader('selectType-loader');
          this.dataPlants = res.message;
          this.openModal(content, true);
        } else {
          this.ngxLoader.stopLoader('selectType-loader');
        }
      },
      err => {
        this.ngxLoader.stopLoader('selectType-loader');
      }
    );
  }

  /* Proceeds with the booking form by plant */
  goBookingByPlant() {
    gtag('event', 'Reserva3', {'event_category': 'Reserva3', 'event_label': 'Reserva3', 'value': 'Reserva3'});
    if (this.plantSelected === null) {
      this.alertSelect = 1;
    } else {
      this.bookingService.setPlantSelected(
        this.plantSelected,
        this.addressSelected,
        this.reference,
        this.codePlant,
        this.latitude,
        this.longitude
      );
      this.modalService.dismissAll();
      this.router.navigateByUrl('/booking/select-plant');
    }
  }

  /* Proceeds with the booking form by date */
  goBookingByDate() {
    if (this.dateModel !== undefined) {
      this.ngxLoader.startLoader('selectType-loader');
      gtag('event', 'Reserva4', {'event_category': 'Reserva4', 'event_label': 'Reserva4', 'value': 'Reserva4'});
      const date = (`${this.dateModel.year}-${this.dateModel.month}-${this.dateModel.day}`);
      this.myMoment = moment.utc(date, 'YYYY-MM-DD').format();
      this.bookingService.getBookingAvailability(this.myMoment).subscribe(
        response => {
          this.ngxLoader.stopBackground('selectType-loader');
          if (response.status === true) {
            for(var key in response.message){
              response.message[key].rangeOfHours =  response.message[key].rangeOfHours.filter(hour => hour.totalForReservation > hour.reservated);
            }
            this.bookingService.setAvailability(response.message);
            this.modalService.dismissAll();
            this.router.navigateByUrl('/booking/select-datetime');
          }
        }
      );
    }
  }

  /* Opens a modal in base of a determinated view element */
  openModal(content, closeLoad = false) {
    this.ngxLoader.startLoader('selectType-loader');
    gtag('event', 'Reserva2', {'event_category': 'Reserva2', 'event_label': 'Reserva2', 'value': 'Reserva2'});
    /* Content types: #bookingByPlant, #bookingByDate */
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true });
    this.openedWindow = null;
    this.btnMaps = 1;
    this.plantSelected = null;
    this.addressSelected = null;
   
    if(closeLoad)
      this.ngxLoader.stopLoader('selectType-loader');
  }

  openWindow(plant, id) {
    this.btnMaps = 0;
    this.plantSelected = plant.plant_name;
    this.addressSelected = plant.address;
    this.reference = plant.reference;
    this.codePlant = plant.prt_plant_code;
    this.latitude = plant.location.coordinates[0];
    this.longitude = plant.location.coordinates[1];
    this.openedWindow = id; // alternative: push to array of numbers
  }

  isInfoWindowOpen(id) {
    return this.openedWindow === id; // alternative: check if id is in array
  }

  /* Closes this modal */
  closeWindow() {
    this.openedWindow = null;
    this.btnMaps = 1;
  }

  /* Converts the interpolated date to a day/month/year format */
  convertStringToFomart(dt, format = 'DD MMMM YYYY') {
    if(dt === "-") return  "Agenda No disponible"; 
    moment.locale('es-es');
    return moment.utc(dt).format(format);
  }
  reAgendarRedirect(){
    this.router.navigate(['/booking/change-booking']);
    gtag('event', 'Reagenda1', {'event_category': 'Reagenda1', 'event_label': 'Reagenda1', 'value': 'Reagenda1'});
  }
}
